<template>
    <div class="card card-round shadow dashboard-widget dashboard-widget--project dashboard-widget--project-information" >
        <div class="card-header">
            <h6 class="mb-0 fw-bold dashboard-widget__title">
                <span class="dashboard-widget__icon" v-html="sidebarSvg.projectDetails"></span>
                <span>{{ $t('Project Information') }}</span>
            </h6>
        </div>
        <div class="card-body p-0 ">
            <table class="table mb-0">
                <tbody>
                    <tr>
                        <td>
                            <b class=" "> {{ $t('Project Address') }}:</b>
                        </td>
                        <td>
                            {{projectInfo.projectAddress}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <b class=" "> {{ $t('Contract Execution Date') }}:</b>
                        </td>
                        <td>
                            {{projectInfo.contractDate}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <b class=" "> {{ $t('Project Commencement Date') }}:</b>
                        </td>
                        <td>
                            {{projectInfo.startDate}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <b class=""> {{ $t('Contract Handover Date') }}:</b>
                        </td>
                        <td>
                            {{projectInfo.handOverDate}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <b class=""> {{ $t('Contract Type') }}:</b>
                        </td>
                        <td>
                            {{projectInfo.contractType}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>


<script>
    import { sidebarSvg } from '@/components/deluxe/DeluxeSidebar.vue'
    export default {
    name : 'ProjectInformationWidget',
    props : ['projectInfo'],
    data(){
        return {
            sidebarSvg
        }
    }
} 
</script>
